import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaHome,
  FaChalkboardTeacher,
  FaListAlt,
  FaThLarge,
  FaUsers,
  FaPlay,
  FaCalendarAlt,
  FaBookmark,
  FaHistory,
  FaGlassCheers,
  FaComments,
  FaMobileAlt,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from "react-icons/fa";

const SideBar = ({ isSidebarOpen, toggleSidebar }) => {
  const navigate = useNavigate();

  const options = [
    { name: "Home", icon: <FaHome />, path: "/" },
    { name: "Classes", icon: <FaChalkboardTeacher />, path: "/classes" },
    { name: "Programs", icon: <FaListAlt />, path: "/programs" },
    { name: "Categories", icon: <FaThLarge />, path: "/categories" },
    { name: "Instructors", icon: <FaUsers />, path: "/instructors" },
    // { name: "Playlists", icon: <FaPlay /> },
    // { name: "Schedule", icon: <FaCalendarAlt /> },
    { name: "Saved", icon: <FaBookmark />, path: "/saved" },
    // { name: "History", icon: <FaHistory /> },
    // { name: "Party", icon: <FaGlassCheers /> },
    { name: "Community", icon: <FaComments />, path: "/community" },
    // { name: "Get App", icon: <FaMobileAlt /> },
  ];

  return (
    <div
      className={`fixed top-0 left-0 h-screen bg-gray-900 text-white flex flex-col transition-all duration-300 shadow-lg ${
        isSidebarOpen ? "w-64" : "w-20"
      }`}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between px-4 py-3">
        {isSidebarOpen && <h1 className="text-xl font-bold">Dance.ai</h1>}
        <button
          onClick={toggleSidebar}
          className="text-white p-2 hover:bg-gray-700 rounded"
        >
          {isSidebarOpen ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />}
        </button>
      </div>

      {/* Scrollable Sidebar Content */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700">
        <ul className="py-4">
          {options.map((option, index) => (
            <li
              key={index}
              className="flex items-center px-4 py-3 hover:bg-gray-800 cursor-pointer"
              onClick={() => navigate(option.path)}
            >
              <span className="text-xl">{option.icon}</span>
              {isSidebarOpen && (
                <span className="ml-3 text-sm font-medium">{option.name}</span>
              )}
            </li>
          ))}
        </ul>

        {/* Additional Sections */}
        <div className="border-t border-gray-700"></div>
        <div className="px-4 py-2">
          <div className="py-2 flex items-center">
            <div className="text-xl">
              <FaThLarge />
            </div>
            {isSidebarOpen && (
              <div className="block px-2 py-1 hover:bg-gray-700 rounded cursor-pointer ml-2">
                Followed Categories
              </div>
            )}
          </div>

          {/* <div className="border-t border-gray-700"></div>
          <div className="py-2 flex items-center">
            <div className="text-xl">
              <FaThLarge />
            </div>
            {isSidebarOpen && (
              <div className="block px-2 py-1 hover:bg-gray-700 rounded cursor-pointer ml-2">
                More from Dance.ai
              </div>
            )}
          </div> */}
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-gray-700 px-4 py-3">
        <p className={`text-xs text-gray-400 ${!isSidebarOpen && "hidden"}`}>
          © 2025 Dance.ai
        </p>
      </div>
    </div>
  );
};

export default SideBar;
